import {
  useWorkflowExecutionMutation,
  WorkflowExecutionApiArg,
} from "../../../features/workflowTriggers/workflowExecution-api";
import {useCallback} from "react";
import {toastError} from "../../../common/utils/toastMessages";

export const useReschedulePickupWorkflow = (
  workflowId: string | null | undefined,
) => {
  if (!workflowId) return {};

  const [runWorkflow, {isLoading, isError, error}] =
    useWorkflowExecutionMutation();

  const reschedulePickup = useCallback(
    async ({orderId, pickupInfo}: any) => {
      if (!workflowId || !orderId || !pickupInfo) return;

      const executeWorkflowApiArgs: WorkflowExecutionApiArg = {
        organizationId: process.env
          .REACT_APP_PORTAL_ORGANIZATION_ID as unknown as number,
        workflowId: workflowId,
        values: {
          variables: {
            orderId,
            pickupInfo,
          },
        },
      };

      const workflowResult: any = await runWorkflow(executeWorkflowApiArgs);

      if (!workflowResult?.data?.outputs?.createPickupRequest) {
        toastError(workflowResult);
        return null;
      }

      return workflowResult?.data?.outputs?.createPickupRequest;
    },
    [runWorkflow, workflowId],
  );

  return {reschedulePickup, isLoading, isError, error};
};
